import clsx from "clsx";
import {
  arrayOf,
  bool,
  element,
  func,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";

import classes from "./RadioCards.module.scss";

const RadioCards = ({
  disabled,
  idPrefix = "",
  onChange,
  options = [],
  value,
  ...props
}) => {
  return (
    <div className={clsx(classes.radio_cards, props.className)}>
      {options.map((option, index) => {
        const {
          align = "center",
          className,
          label,
          value: optionValue,
        } = option;
        const id = idPrefix
          ? `${idPrefix}-${optionValue}`
          : String(optionValue);

        return (
          <div
            className={clsx(classes["radio_cards__card"], className)}
            data-disabled={disabled}
            key={index}
            style={{ alignItems: align }}
          >
            <input
              checked={value === optionValue}
              disabled={disabled}
              id={id}
              name={id}
              onChange={(e) => onChange(optionValue, option, e)}
              type="radio"
              data-clarity-mask="True"
            />

            <label htmlFor={id}>{label}</label>
          </div>
        );
      })}
    </div>
  );
};

RadioCards.propTypes = {
  className: string,
  disabled: bool,
  idPrefix: string,
  onChange: func,
  options: arrayOf(
    shape({
      align: string,
      className: string,
      label: oneOfType([element, string]),
      value: oneOfType([bool, string, number]),
    })
  ),
  value: oneOfType([bool, string, number]),
};

export default RadioCards;
